export class ClientCustomization {
  footerLogo: ICustomizationAttachment;
  backgroundPicture: ICustomizationAttachment;
  colorScheme: ICustomizationAttachment;

  constructor(customizationLikeObject = {}) {
    Object.assign(this, customizationLikeObject);
  }

  isFooterLogoDefined(): boolean {
    return !!(this.footerLogo && this.footerLogo.id);
  }

  isBackgroundImageDefined(): boolean {
    return !!(this.backgroundPicture && this.backgroundPicture.id);
  }

  isCustomCssDefined(): boolean {
    return !!(this.colorScheme && this.colorScheme.fileName);
  }
}

interface ICustomizationAttachment {
  columnName: string;
  displayName: string;
  fileName: string;
  fileSize: string;
  id: string;
  mimeTypeName: string;
  thumbnailId: string;
}
